module.exports = __webpack_public_path__ + "img/P@2x.a488842.webp";